import { render, staticRenderFns } from "./widgetTable.vue?vue&type=template&id=dd370d12"
import script from "./widgetTable.vue?vue&type=script&lang=js"
export * from "./widgetTable.vue?vue&type=script&lang=js"
import style0 from "./widgetTable.vue?vue&type=style&index=0&id=dd370d12&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports